import { Input } from "@thetreep/ui";
import React, { useEffect } from "react";

export function InputFilter({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.ComponentProps<typeof Input>, "onChange" | "value">) {
  const [value, setValue] = React.useState(initialValue);
  const [prevInitialValue, setPrevInitialValue] = React.useState(initialValue);

  if (initialValue !== prevInitialValue) {
    setPrevInitialValue(initialValue);
    setValue(initialValue);
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <Input
      {...props}
      kind="filter"
      overrides={{
        Root: {
          style: {
            borderRadius: "100px",
            borderStyle: "none",
          },
        },
        Input: {
          style: {
            borderRadius: "100px",
            borderColor: "#c6c6c6",
            borderWidth: "1px",
            borderStyle: "solid",
            fontSize: "14px",
          },
        },
      }}
      onChange={(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
      ) => {
        setValue(e.target.value);
      }}
      value={value}
    />
  );
}
